import { useContext, useMemo, useState } from 'react';

import { useRouter } from 'next/router';
import Link from 'next/link';
import Image from 'next/image';

import { TermsModal } from '~/modules/signup/pages/Modals/termsModal';
import { PoliticasModal } from '~/modules/signup/pages/Modals/politicasModal';

import { PublicShowGlowContext } from '~/common/providers/public-circular-glow';
import { Typography } from '~/common/components/Typography';
import { CircularGlow } from '~/common/components/CircularGlow';

import {
  StyContainer,
  StyWrapper,
  StyFooter,
  StyLogoImage,
  StyContent,
  StyLinks,
  StyPrivacity,
} from './styles';
import { CompanyInfoModal } from './company-info-modal';
import { AboutUsModal } from './about-us-modal';
import cryptocontrol_small_logo from '../../common/assets/icons/cryptocontrol_small_logo.svg';

interface IPublicLayout {
  children?: any;
  title?: string;
}

export const PublicLayout: React.FC<IPublicLayout> = ({ children, title }) => {
  const { showGlow } = useContext(PublicShowGlowContext);
  const [openTerms, setOpenTerms] = useState<boolean>(false);
  const [openPoliticas, setOpenPoliticas] = useState<boolean>(false);
  const [openAboutUs, setOpenAboutUs] = useState<boolean>(false);
  const [openCompanyInfo, setOpenCompanyInfo] = useState<boolean>(false);
  const router = useRouter();

  const isAtSignUp = useMemo(
    () => router.asPath.includes('signup'),
    [router.asPath]
  );

  return (
    <>
      <PoliticasModal
        open={openPoliticas}
        close={() => setOpenPoliticas(false)}
      />
      <TermsModal open={openTerms} close={() => setOpenTerms(false)} />
      <AboutUsModal open={openAboutUs} close={() => setOpenAboutUs(false)} />
      <CompanyInfoModal
        open={openCompanyInfo}
        close={() => setOpenCompanyInfo(false)}
      />

      <StyContainer>
        {showGlow && <CircularGlow />}
        <StyWrapper id="public-layout-wrapper-id">
          <StyLogoImage>
            <Link href="/">
              <Image src={cryptocontrol_small_logo} alt="" width={55} />
            </Link>
          </StyLogoImage>
          <StyContent id="public-layout-content-id">
            {!!title && <Typography.Title size="h4">{title}</Typography.Title>}
            {children}
          </StyContent>
          <StyFooter>
            <Typography.Label size="x-small" color="neutral.400">
              CRYPTOCONTROLLABS LTDA - CNPJ: 52.905.625/0001-04 - Endereço: AV
              BRIG FARIA LIMA, SALA ESC 1119 nº 1811, SÃO PAULO, SP, 01.452-001,
              Brasil
            </Typography.Label>

            <StyLinks>
              <StyPrivacity onClick={() => setOpenAboutUs(true)}>
                <Typography.Label size="x-small" color="green.500">
                  sobre nós
                </Typography.Label>
              </StyPrivacity>

              <StyPrivacity onClick={() => setOpenCompanyInfo(true)}>
                <Typography.Label size="x-small" color="green.500">
                  Informações da empresa
                </Typography.Label>
              </StyPrivacity>

              {!isAtSignUp && (
                <>
                  <StyPrivacity onClick={() => setOpenTerms(true)}>
                    <Typography.Label size="x-small" color="green.500">
                      termos de uso
                    </Typography.Label>
                  </StyPrivacity>

                  <StyPrivacity onClick={() => setOpenPoliticas(true)}>
                    <Typography.Label size="x-small" color="green.500">
                      políticas de privacidade
                    </Typography.Label>
                  </StyPrivacity>
                </>
              )}
            </StyLinks>
          </StyFooter>
        </StyWrapper>
      </StyContainer>
    </>
  );
};
